import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { Goodcatch } from './goodCatch.interface';
import { environment } from '../../../environments/environment';
import { buildAnalyticsParams } from '../analytics-params';

@Injectable({
    providedIn: 'root'
  })

export class GoodCatchService {
    private apiUrl = `${environment.apiConfig.uri}/goodcatch`;
    private apiUrlExport = `${environment.apiConfig.uri}/goodcatch/export`;
    private apiUrlPdf = `${environment.apiConfig.uri}/goodcatch/getPdf`;
    private apiUrlTotals = `${environment.apiConfig.uri}/goodcatch/totals`;

    constructor(private http: HttpClient) {
    }

    createGoodCatch(newGoodcatch: Goodcatch): Observable<any> {
        return this.http.post(this.apiUrl, {
            email: newGoodcatch.email,
            type: newGoodcatch.type,
            incidentDate: newGoodcatch.incidentDate,
            supervisor: newGoodcatch.supervisor,
            office: newGoodcatch.office,
            dateOfReport: newGoodcatch.dateOfReport,
            time: newGoodcatch.time,
            location: newGoodcatch.location,
            typeCatch: newGoodcatch.typeCatch,
            equipment: newGoodcatch.equipment,
            persons: newGoodcatch.persons,
            desc: newGoodcatch.desc,
            rate: newGoodcatch.rate,
            actions: newGoodcatch.actions,
            dateDiscussed: newGoodcatch.dateDiscussed,
            completedBy: newGoodcatch.completedBy,
            title: newGoodcatch.title,
            signature: newGoodcatch.signature,
            signatureOne: newGoodcatch.signatureOne,
            signatureTwo: newGoodcatch.signatureTwo,
            signatureThree: newGoodcatch.signatureThree,
            signatureFour: newGoodcatch.signatureFour
        })
    }

    getGoodCatchPdfs(): Observable<any> {
        return this.http.get<any>(this.apiUrlPdf);
    }

    getGoodCatchTotalsByMonth(offices?: string[], startDate?: Date, endDate?: Date): Observable<any> {
        return this.http.get<any>(this.apiUrlTotals, { params: buildAnalyticsParams(offices, startDate, endDate) });
    }

    exportGoodCatchExcel(): Observable<Blob> {
        return this.http.get(this.apiUrlExport, {
            responseType: 'blob'
        })
    }


}